import { TabsRoot } from './Tabs'
import { TabsBadge } from './TabsBadge'
import { TabsCell } from './TabsCell'
import { TabsCells } from './TabsCells'
import { TabsColumn, TabsContentWrapper } from './TabsContentWrapper'
import { TabsTextCell } from './TabsTextCell'

export const Tabs = Object.assign(TabsRoot, {
  Cells: TabsCells,
  Cell: TabsCell,
  TextCell: TabsTextCell,
  Badge: TabsBadge,
  Content: TabsContentWrapper,
  Column: TabsColumn,
})

export * from './types'
